import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FilterItems from '../filterItems/FilterItems';
import TooltipContainer from "../../atoms/toolTip/Tooltip";
import labels from "../../../config/labels";
import styles from './Contracttype.module.scss';

const ContractType = (props) => {
  const selectedKeys = Object.keys(props?.selectedFilter);
  let [selectedRadio, setSelectedRadio] = useState(false);
  let [selectedContract, setSelectedContract] = useState();
  let tooltips = props?.contractsList?.filter(data => props?.contracttypes?.sort((a, b) => a.value - b.value).some(item => data.contract_type_option_label === item.label));

  const onRadioChange = (value) => {
    setSelectedContract(value.label);
    setSelectedRadio(!selectedRadio);
    props.onContractTypeChange(true, value);
  };

  // useEffect(() => {
  //   setSelectedContract(props?.filteredContractType ?
  //     props?.filteredContractType?.map(item => item.label)[0] : '');
  //   props?.contracttypes?.map((item) => {
  //     if (selectedContract == item.label) {
  //       document.getElementById(item.label).checked = true;
  //     }
  //     else {
  //       document.getElementById(item.label).checked = false;
  //     }
  //   })
  // }, [props.filteredContractType, selectedContract, props?.contracttypes])

  useEffect(() => {
    if (selectedKeys.length === 1 && selectedKeys[0] === "updateFilterCriteria") {
      setSelectedContract('');
      return;
    }
    if (!selectedKeys.includes(labels.lbl_contractType.toLowerCase())) {
      setSelectedContract('');
      return;
    }
    if (props?.selectedFilter?.contracttype) {
      const [contract] = props.selectedFilter.contracttype || [];
      setSelectedContract(contract && contract?.label);
      setSelectedRadio(!!contract);
    }
  }, [props?.selectedFilter]);

  return (
    <>
      <div className="d-none d-lg-block">
        {props?.contracttypes && props?.contracttypes.length > 0 && (
          <div className="d-flex align-items-center">
            <p className={styles.priceHeading}>Contract type</p>
            <TooltipContainer>
              <div>
                {tooltips?.map((data, index) => {
                  return (
                    <div className={styles.description} key={`contract_type_${data?.contract_type_option_label}_${index}`}>
                      <div className={`d-flex ${styles.title}`}>
                        {data?.contract_type_option_label}
                      </div>
                      <div className={`d-flex`}>{data?.contract_type_desc}</div>
                    </div>
                  );
                })}
              </div>
            </TooltipContainer>
          </div>
        )}
        <div className={styles.radiobtn}>
          {props?.contracttypes?.map((item, index) => (
            <div className={styles.radiobtnDiv} key={`radio_contract_type_${index}`}>
              <label className={styles.radio}>
                <input
                  type="radio"
                  id={`rb_contract_type_${item.label}`}
                  value={item.label}
                  checked={selectedContract === item.label}
                  onClick={() => onRadioChange(item)}
                  onChange={() => { }}
                />
                <label htmlFor={`rb_contract_type_${item.label}`}>{item.label}</label>
                <span></span>
              </label>
            </div>
          ))}
        </div>
      </div>

      <FilterItems heading="Contract type" handleClick={props.toggleContractTypes}
        id={props?.displayContractType == true && props?.filteredContractType?.length ? `filtered_contracts_${props?.filteredContractType}` : null}
        renderFun={props?.filteredContractType?.map(contract => contract.label).join(", ")}
      />
    </>
  );
};

ContractType.propTypes = {
  selectedFilter: PropTypes.object,
  displayContractType: PropTypes.bool,
  toggleContractTypes: PropTypes.func,
  onContractTypeChange: PropTypes.func,
  contracttypes: PropTypes.array,
  contractsList: PropTypes.array,
  filteredContractType: PropTypes.array,
};

export default ContractType;
